import React from 'react';
import Container from '../components/Container';
import Typography from '../components/Typography';

export default function TezosToETH() {
    return (
        <Container>
            <Typography variant="body1">
                Coming soon...
            </Typography>
        </Container>
    )
}
